export default __webpack_public_path__ + "static/B0290-2dd1dba9067f17ceb3c16b16e2d22de3.png";